import React, { useMemo } from 'react'

import PropTypes from 'prop-types'

import isEmpty from 'lodash/isEmpty'

import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Divider from '@material-ui/core/Divider'
import Typography from '@material-ui/core/Typography'

import fonts from '@galo-monitor/styles/fonts'
import Breadcrumbs from '@galo-monitor/web-components/Breadcrumbs'

import useStyles from './styles'

const Screen = props => {
  const { title, withCard, children, headerChildren, breadcrumbs, removeDivider } = props

  const classes = useStyles()

  const content = useMemo(
    () => !withCard ? children : (
      <Card>
        <CardContent>
          {children}
        </CardContent>
      </Card>
    ),
    [children, withCard]
  )

  return (
    <>
      {title && (
        <>
          <div className={ classes.contentHeader }>
            <div className={ classes.headerFlex }>
              <div>
                <Typography
                  variant="h6"
                  style={ {
                    fontWeight: fonts.fontWeight.bold,
                    letterSpacing: '-0.035em'
                  } }
                >
                  {title}
                </Typography>
                {!isEmpty(breadcrumbs) && <Breadcrumbs breadcrumbs={ breadcrumbs } />}
              </div>
              { headerChildren }
            </div>
            {removeDivider ? null : <Divider />}
          </div>
        </>
      )}
      {content}
    </>
  )
}

Screen.propTypes = {
  title: PropTypes.string,
  withCard: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
  headerChildren: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
  breadcrumbs: PropTypes.array,
  removeDivider: PropTypes.bool
}

Screen.defaultProps = {
  title: '',
  children: null,
  headerChildren: null,
  withCard: false,
  breadcrumbs: [],
  removeDivider: false
}

export default Screen
